// extracted by mini-css-extract-plugin
module.exports = {"content":"dashboardelement_content__Ht_Df"};